import { observer } from 'mobx-react-lite'
import { TableSearch } from 'shared/ui/TableNew'
import { Divider } from 'shared/ui'
import { createAircallColumns } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/ui/AircallTable/columns/aircallColumns'
import { AircallTable } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/ui/AircallTable/AircallTable'
import { AssignedNotFoundMessage } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/ui/AssignedNotFoundMessage/AssignedNotFoundMessage'
import { type AircallNumbersStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/store/AircallNumbersStore'
import { UpdateAircallNumbersLayout } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationAircallSettings/ui/UpdateAircallNumbersLayout/UpdateAircallNumbersLayout'

type IAssignedNumbersProps = {
  store: AircallNumbersStore
}

export const AssignedNumbers = observer(({ store }: IAssignedNumbersProps) => {
  const columns = createAircallColumns(store.numbersListStore)
  const { numbersListStore } = store

  return (
    <>
      <Divider sx={{ marginBottom: '16px' }} />
      {numbersListStore.assignedNumbersLength > 0 && (
        <TableSearch value={numbersListStore.search} onChange={numbersListStore.setSearch} />
      )}
      <AircallTable
        store={numbersListStore}
        rows={numbersListStore.assignedItems}
        hidePagination={true}
        withoutSelectedCount={true}
        emptyContent={
          numbersListStore.assignedNumbersLength === 0 &&
          numbersListStore.unassignedNumbersLength === 0 ? (
            <UpdateAircallNumbersLayout store={numbersListStore} />
          ) : null
        }
        notFoundMessage={<AssignedNotFoundMessage store={store} />}
        columns={[columns.numberCell, columns.statusCell, columns.inboxCell]}
        ariaLabel={'AssignedNumbers'}
      />
    </>
  )
})
